import { Outlet } from 'react-router-dom';
import LoadingState from 'components/loadingState/LoadingState';
import { useSelectedContract } from 'hooks';

const ContractInformationLayout = () => {
  const { isLoading } = useSelectedContract();

  if (isLoading) return <LoadingState />;

  return <Outlet />;
};

export default ContractInformationLayout;
